import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactElement;
  role?: 'TECHNICIAN' | 'ADMIN';
}

// Helper to check if user is an admin type (ADMIN or ADMIN_STAFF)
const isAdminRole = (userRole?: string) => {
  return userRole === 'ADMIN' || userRole === 'ADMIN_STAFF';
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, role }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner spinner-large"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role access
  if (role) {
    if (role === 'ADMIN') {
      // Admin routes allow both ADMIN and ADMIN_STAFF
      if (!isAdminRole(user?.role)) {
        return <Navigate to="/technician" replace />;
      }
    } else if (role === 'TECHNICIAN') {
      // Technician routes only allow TECHNICIAN
      if (user?.role !== 'TECHNICIAN') {
        const redirectPath = isAdminRole(user?.role) ? '/admin' : '/technician';
        return <Navigate to={redirectPath} replace />;
      }
    }
  }

  return children;
};

export default PrivateRoute;
